<template>
    <div>
      <div class="fixBottomBtn">
  <a :href="`${signupUrl}&utm_source=bestbroker&utm_content={$utm_content|default=''}`" target="_blank" class="primary-default_large">
    开始交易
  </a>
</div>
        <a class="forex-bottom-details-show-box"
            :href="`${signupUrl}&utm_source=bestbroker&utm_content={$utm_content|default=''}`"
            target="_blank" rel="nofollow">
            <div class="forex-bottom-details-show-left">
                <div class="forex-bottom-details-show-honner-box">
                    <img class="forex-bottom-details-show-honner-icon"
                        src="../../assets/image/forex/banner/icon-left.png" alt="" />
                    <div class="forex-bottom-details-show-honner-name-box">
                        <p class="forex-honner-honner-name">全球最佳券商</p>
                        <p class="forex-honner-honner-name-en">World's Best Broker</p>
                    </div>
                    <img class="forex-bottom-details-show-honner-icon"
                        src="../../assets/image/forex/banner/icon-right.png" alt="" />
                </div>
                <div class="mobile">
                    <div class="forex-bottom-details-show-btn">立即开户</div>
                </div>
            </div>
            <div class="forex-bottom-details-show-right">
                <img class="forex-bottom-details-show-player-img pc" src="../../assets/image/forex/banner/player.png"
                    alt="" />
                <img class="forex-bottom-details-show-logo mobile" src="../../assets/image/logo/logo_row.svg" alt="" />
                <img class="forex-bottom-details-show-player-img mobile"
                    src="../../assets/image/forex/banner/player_m.png" alt="" />
                <div class="forex-bottom-details-show-logo-box">
                    <img class="forex-bottom-details-show-logo" src="../../assets/image/logo/logo_row.svg" alt="" />
                    <div class="forex-bottom-details-show-btn">立即开户</div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: "footer-detail",
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
    mounted(){
      window.onscroll = (f => () => requestAnimationFrame(f))(() => {
    document.querySelector('.fixBottomBtn').classList.toggle('showFixBottomBtn', scrollY > innerHeight);
});
    }
}

</script>

<style scoped>
    .forex-bottom-details-show-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 140rem;
  width: 100%;
  /* width: 760rem; */
  background-image: url("../../assets/image/forex/banner/bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  padding-left: 42rem;
  padding-right: 26rem;
  border-radius: 8rem;
  margin-top: 56rem;
}
.forex-bottom-details-show-honner-box {
  display: flex;
  align-items: center;
}
.forex-bottom-details-show-honner-icon {
  width: 60rem;
}
.en .forex-bottom-details-show-honner-icon {
  width: 38rem;
}
.forex-bottom-details-show-honner-name-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8rem;
  flex-shrink: 0;
}
.forex-honner-honner-name {
  margin-bottom: 0;
  font-size: 32rem;
  font-weight: 700;
  background: linear-gradient(92deg, #c2936a 0.01%, #9f734c 100.01%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
}
.en .forex-honner-honner-name {
  font-size: 24rem;
}
.vi .forex-honner-honner-name {
  line-height: 1.25;
}
.forex-honner-honner-name-en {
  margin-bottom: 0;
  color: var(--Text-Tertiary, rgba(0, 0, 0, 0.48));
  text-align: center;
  font-size: 18rem;
  font-style: normal;
  font-weight: 400;
}
.en .forex-honner-honner-name-en {
  display: none;
}
.forex-bottom-details-show-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* gap: 28rem; */
  height: 100%;
}
.forex-bottom-details-show-player-img {
  width: 210rem;
  align-self: flex-end;
  flex-shrink: 1;
}
.forex-bottom-details-show-logo-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14rem;
  flex-shrink: 0;
}
.forex-bottom-details-show-logo {
  height: 22rem;
}

.forex-bottom-details-show-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44rem;
  border-radius: 22rem;
  padding: 0 24rem;
  background: #a52933;
  color: var(--Text-Primary_White, #fff);
  text-align: center;
  font-size: 14rem;
  font-style: normal;
  font-weight: 500;
  line-height: 1;
  animation: forexBtnAnimation 1.2s infinite;
}
@keyframes forexBtnAnimation{
  0%{
    transform: scale(0.8);
  }
  50%{
    transform: scale(1.1);
  }
  100%{
    transform: scale(0.8);
  }
}
.forex-bottom-details-show-btn:hover {
  background: #cc333f;
  color: #fff;
}
.forex-bottom-details-show-btn:active {
  background: #7b1e26;
}
.fixBottomBtn{
  display: none;
}
@media (max-width: 996px) {
  .showFixBottomBtn{
  display: none!important;
  }
  .fixBottomBtn{
  position: fixed;
  left:0;
  bottom: 0;
  width: 100%;
  z-index: 999;
  padding: 20rem 32rem 30rem;
  background: #FFF;
  box-shadow: 0 -1px 10px 0 rgba(0, 0, 0, 0.10);
}
  .fixBottomBtn a{
    color: #fff!important;
  }
  .forex-bottom-details-show-box {
    margin-top: 88rem;
    min-height: 240rem;
    padding-left: 34rem;
    padding-right: 14rem;
  }
  .forex-bottom-details-show-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24rem;
  }
  .forex-honner-honner-name {
    font-size: 38rem;
  }
  .en .forex-honner-honner-name {
    font-size: 28rem;
  }
  .forex-honner-honner-name-en {
    display: none;
  }
  .forex-bottom-details-show-honner-icon {
    width: 50rem;
  }
  .en .forex-bottom-details-show-honner-icon {
    width: 48rem;
  }
  .forex-bottom-details-show-logo-box {
    display: none;
  }
  .forex-bottom-details-show-btn {
    height: 46rem;
    border-radius: 23rem;
    padding: 0 48rem;
    font-size: 20rem;
  }
  .forex-bottom-details-show-player-img {
    width: 290rem;
  }
  .forex-bottom-details-show-logo {
    height: 32rem;
  }
  .forex-bottom-details-show-right {
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    gap: 10rem;
  }
}

</style>